module.exports = __webpack_public_path__ + "img/5.699d48d6.jpg";